<template>
  <div class="item">
    <v-row :class="[isMobile ? 'column-reverse' : 'row']">
      <v-col cols="12" md="6">
        <component :is="getComponentLeft()" orientation="left" :isMobile="isMobile">
          <template v-if="getComponentLeft() == 'col-text'">
            <template slot="title">
              <slot name="title"/>
            </template>
            <template slot="text">
              <slot name="text"/>
            </template>
          </template>
          <template v-else>
            <template slot="image">
              <slot name="image"/>
            </template>
          </template>
        </component>
      </v-col>
      <v-col md="6" cols="12">
        <component :is="getComponentRigth()" orientation="right" :isMobile="isMobile">
          <template v-if="getComponentRigth() == 'col-text'">
            <template slot="title">
              <slot name="title"/>
            </template>
            <template slot="text">
              <slot name="text"/>
            </template>
          </template>
          <template v-else>
            <template slot="image">
              <slot name="image"/>
            </template>
          </template>
        </component>
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss" scoped>
  @import '../../assets/styles.scss';
  @import './feature-style.scss';
</style>

<script>
  import imgAPI from '../../static/images/imgAPI'
  import Image from './Image';
  import Text from './Text';
  
  export default {
    components: {
      'col-image': Image,
      'col-text': Text
    },
    data() {
      return {
        tab: null,
        imgAPI: imgAPI,
        loaded: false,
        items: ['col-image', 'col-text'],
        val: _.random(0,0)
      }
    },
    mounted() {
      this.loaded = true
    },
    methods: {
      getComponentRigth() {
        return this.items[this.val];
      },
      getComponentLeft() {
        return this.items[(this.val === 1 ? 0 : 1)];
      }
    },
    computed: {
      isDesktop() {
        const lgUp = ['lgDown', 'xl']
        return lgUp.indexOf(this.$mq) > -1
      },
      isMobile() {
        const smDown = ['smDown', 'xsDown']
        return smDown.indexOf(this.$mq) > -1
      }
    }
  }
</script>
